import KunLoading62 from './src/index'

KunLoading62.install = function (Vue) {
	Vue.component(KunLoading62.name, KunLoading62);
}

export default KunLoading62;
